import { resolveRoute, bestMatch, } from "@inlang/paraglide-js/internal/adapter-utils";
export function getTranslatedPath(canonicalPath, lang, translations, matchers) {
    const match = bestMatch(canonicalPath, Object.keys(translations), matchers);
    if (!match)
        return canonicalPath;
    const translationsForPath = translations[match.id];
    if (!translationsForPath)
        return canonicalPath;
    const translatedPath = translationsForPath[lang];
    if (!translatedPath)
        return canonicalPath;
    return resolveRoute(translatedPath, match.params);
}
